import { forwardRef, useImperativeHandle, useState } from 'react';
import { Error, Input, InputContainer, InputSection, Label } from './styled';

const InputField = forwardRef((props, ref) => {
  // 语言 en/zh
  const language = props.chatLanguage;
  const device = props.$device;

  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  /**
   * 不知道是什么，但是加载此组件时会执行此函数，用于设置校验规则函数
   */
  useImperativeHandle(ref, () => {
    return {
      validate: () => validate(),
    };
  });

  /**
   * 设置字段的校验规则
   * @returns 校验结果true/false
   */
  const validate = () => {
    // 配置中的校验规则
    const validation = props.validation;

    // 如果字段的校验规则为空或notRequired时，退出不校验。
    if (!validation || validation === 'notRequired') {
      return true;
    }

    // error提示消息
    let message = '';

    // 如果是required时，只校验必填
    if (validation === 'required') {
      if (!value) {
        message = language === 'zh' ? '此字段为必填项' : 'required';
        setError(message);
        return false;
      }
    }
    // 使用validation字段值进行正则校验
    else {
      if (!value) {
        message = language === 'zh' ? '此字段为必填项' : 'required';
        setError(message);
        return false;
      } else {
        if (validation.test(value)) {
          return true;
        }
        if (props.code === 'chat_user_name') {
          message = language === 'zh' ? '请输入有效的客户名' : 'Please enter a valid user name';
        } else if (props.code === 'chat_email') {
          message = language === 'zh' ? '请输入有效的电子邮件地址' : 'Please enter a valid email';
        } else if (props.code === 'chat_phone_number') {
          message = language === 'zh' ? '请输入有效的手机号' : 'Please enter a valid phone number';
        } else {
          message = language === 'zh' ? '请输入有效字符' : 'Please enter a valid value';
        }
        setError(message);
        return false;
      }
    }

    return true;
  };

  /**
   * 获取表单input中的icon标签
   * @param name input code
   * @returns 图标标签
   */
  const getFormFieldIcon = (name) => {
    if (name === 'chat_user_name') {
      return <UserSvg style={{ width: '100%', height: '100%' }} />;
    } else if (name === 'chat_email') {
      return <EmailSvg style={{ width: '100%', height: '100%' }} />;
    } else if (name === 'chat_phone_number') {
      return <PhoneNumberSvg style={{ width: '100%', height: '100%' }} />;
    } else {
      return null;
    }
  };

  /**
   * 表单输入框的变化事件
   * @param e
   */
  const handleChange = (e) => {
    setValue(e.target.value);
    setError('');
    props.onChange(e.target.name, e.target.value);
  };

  const inputMaxLength = (name) => {
    if (name === 'chat_user_name') {
      return 16;
    } else if (name === 'chat_email') {
      return 40;
    } else {
      return 50;
    }
  };

  return (
    <InputSection>
      <Label>{props.label}</Label>
      <InputContainer $device={device}>
        {getFormFieldIcon(props.name)}
        <Input
          type="text"
          maxLength={inputMaxLength(props.name)}
          name={props.name}
          value={props.value ? props.value : value}
          onChange={(e) => handleChange(e)}
          autoComplete={props.autoComplete}
        />
      </InputContainer>
      {error && <Error>{error}</Error>}
    </InputSection>
  );
});

InputField.defaultProps = {
  placeholder: '',
  name: '',
  value: '',
  type: '',
  autoComplete: 'off',
  validation: '',
};

export default InputField;

// 输入框中用户名的图标
const UserSvg = () => (
  <svg width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.04047 6.81403C4.7245 6.81403 3.65763 5.73657 3.65763 4.40724C3.65763 3.07792 4.7245 2 6.04047 2C7.35644 2 8.42331 3.07746 8.42331 4.40724C8.42331 5.73611 7.35644 6.81403 6.04047 6.81403ZM6.04047 6.18597C7.01294 6.18597 7.8017 5.38939 7.8017 4.40724C7.8017 3.42464 7.01294 2.62806 6.04047 2.62806C5.06799 2.62806 4.27924 3.42464 4.27924 4.40724C4.27924 5.38939 5.06799 6.18597 6.04047 6.18597ZM6.04047 11C4.53847 11 3.93528 10.9738 3.33623 10.8402C2.48025 10.6496 2 10.2223 2 9.49018C2 8.08073 3.83168 7.02307 6.04047 7.02307C8.24926 7.02307 10.0809 8.08073 10.0809 9.49018C10.0809 10.2223 9.60069 10.6496 8.7447 10.8402C8.14566 10.9738 7.54246 11 6.04047 11ZM6.04047 10.3719C8.69129 10.3719 9.45933 10.2007 9.45933 9.49018C9.45933 8.52139 7.95135 7.65113 6.04047 7.65113C4.12959 7.65113 2.62161 8.52139 2.62161 9.49018C2.62161 10.2007 3.38965 10.3719 6.04047 10.3719Z"
      fill="#999999"
    />
  </svg>
);
// 输入框中邮箱的图标
const EmailSvg = () => (
  <svg width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.01" width="20" height="20" fill="black" />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.875 1.875H1.125C0.917578 1.875 0.75 2.04258 0.75 2.25V9.75C0.75 9.95742 0.917578 10.125 1.125 10.125H10.875C11.0824 10.125 11.25 9.95742 11.25 9.75V2.25C11.25 2.04258 11.0824 1.875 10.875 1.875ZM10.4063 3.17383V9.28164H1.59377V3.17383L1.27033 2.92188L1.27085 2.92121L1.59264 3.17188L5.59577 6.28438C5.83248 6.46836 6.16412 6.46836 6.40084 6.28438L10.4063 3.17305L10.7297 2.92109L10.27 2.33033L10.2703 2.33008L10.7309 2.92188L10.4063 3.17383ZM9.7663 2.72031L9.76881 2.71836L10.2692 2.3293L10.27 2.33033L9.76877 2.72031H9.7663ZM9.7663 2.72031L6.00006 5.64805L2.23382 2.72031H9.7663ZM2.23382 2.72031H2.23244L1.73088 2.33008L1.27085 2.92121L1.2692 2.91992L1.72975 2.32812L2.23131 2.71836L2.23382 2.72031Z"
      fill="#333333"
    />
  </svg>
);
// 输入框中手机号的图标
const PhoneNumberSvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.99033 4.87254C3.30665 4.34878 5.0495 2.44376 6.29322 2.50127C6.665 2.53208 6.99364 2.75699 7.26067 3.01784C7.87379 3.61656 9.62897 5.88101 9.72859 6.35753C9.97096 7.52621 8.57833 8.1999 9.00454 9.37783C10.0911 12.0366 11.9634 13.9088 14.6233 14.9943C15.8003 15.4205 16.474 14.0279 17.6428 14.2713C18.1183 14.3709 20.3839 16.126 20.9826 16.7391C21.2425 17.0051 21.4684 17.3347 21.4992 17.7065C21.5454 19.0159 19.5222 20.7833 19.1278 21.0092C18.1974 21.6747 16.9834 21.6634 15.5035 20.9753C11.3739 19.2572 4.77426 12.7822 3.02422 8.49669C2.35461 7.02505 2.30839 5.80297 2.99033 4.87254Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
